import React from 'react';
import './MenuMesChantiersPage.scss';
import { Container } from '@design-system';
import { PageMenuItem } from '@components';
import { useNavigate } from 'react-router-dom';

import { IoBagHandleSharp, IoLibrary } from 'react-icons/io5';
import { BsClipboard2CheckFill } from 'react-icons/bs';
import { PiListChecksFill } from 'react-icons/pi';
import { BiSolidBarChartAlt2, BiSolidMessageAltError } from 'react-icons/bi';

export const MenuMesChantiersPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container className="menu-mes-chantiers-page">
            <Container padding="none" row>
                <PageMenuItem
                    title="Appro-visionnement"
                    icon={<IoBagHandleSharp />}
                    onClick={() => navigate('/mes-chantiers/approvisionnement')}
                    color="red"
                />
                <PageMenuItem
                    title="Levée de réserve et quitus"
                    icon={<BsClipboard2CheckFill />}
                    onClick={() => navigate('/mes-chantiers/quitus')}
                    color="red"
                />
                <PageMenuItem
                    title="Essai / AQC"
                    icon={<PiListChecksFill />}
                    onClick={() => navigate('/mes-chantiers/testsheets')}
                    color="red"
                />
                <PageMenuItem
                    title="Mes résultats de chantier"
                    icon={<BiSolidBarChartAlt2 />}
                    onClick={() => navigate('/mes-chantiers/my-worksite-results')}
                    color="red"
                    wip
                />
                <PageMenuItem
                    title="Remontée d'évènement"
                    icon={<BiSolidMessageAltError />}
                    onClick={() => navigate('/mes-chantiers/event-feedback')}
                    color="red"
                />
                <PageMenuItem
                    title="Bibliothèque chantier"
                    icon={<IoLibrary />}
                    onClick={() => navigate('/mes-chantiers/bibliotheque')}
                    color="red"
                />
            </Container>
        </Container>
    );
};
